'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _windowWrapper = require('../sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TranslationUtil = function () {
  function TranslationUtil() {
    (0, _classCallCheck3.default)(this, TranslationUtil);

    this._translations = (0, _assign2.default)({}, (0, _extends3.default)({}, _windowWrapper2.default.translations));
  }

  (0, _createClass3.default)(TranslationUtil, [{
    key: 'setTranslations',
    value: function setTranslations(translations) {
      (0, _assign2.default)(this._translations, (0, _extends3.default)({}, translations));
    }
  }, {
    key: 'getByKey',
    value: function getByKey(strKey) {
      try {
        var strValue = null;
        if (this.translations) {
          strValue = this.translations[strKey] || _windowWrapper2.default.translations[strKey];
        }

        if (!strValue) {
          strValue = strKey;
        }

        if (_windowWrapper2.default) {
          if (_windowWrapper2.default.isClientDev) {
            strValue = strKey;
          }
          if (_windowWrapper2.default.unescape) {
            strValue = _windowWrapper2.default.unescape(strValue); // for chars that come from babel like &#39;
          }
        }

        return strValue;
      } catch (e) {
        return strKey;
      }
    }
  }, {
    key: 'translations',
    get: function get() {
      return this._translations;
    }
  }]);
  return TranslationUtil;
}();

exports.default = new TranslationUtil();